<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Order Online</h1>
                        <p>"Craving wings or sandwiches? Order online and we'll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="error-section mt-5 mb-3">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <img src="../../../../assets/img/home2/error.jpg" class="itemImage" width="220" alt="error">
                <p class="errorParagraph">"Oops! Something went wrong with your order."</p>
                <p class="errorSubtext">Please try again or contact support if the problem persists.</p>
                
                <div class="action-buttons mt-4">
                    <a href="cart" class="btn btn-primary me-3">Try Again</a>
                </div>
                
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>